import React from "react"
import { Calendar, Pencil } from "lucide-react"
import LearnerModal from "../../components/LearnerModal"
import type { NoteCardViewModel } from "../types"
import "./NoteDetailModal.style.scss"

interface NoteDetailModalProps {
  note: NoteCardViewModel | null
  onClose: () => void
  onEdit: (note: NoteCardViewModel) => void
}

const NoteDetailModal = ({ note, onClose, onEdit }: NoteDetailModalProps) => (
  <LearnerModal
    isOpen={Boolean(note)}
    title={note?.title || "Note"}
    dialogClassName="is-note-detail"
    onClose={onClose}
    footer={
      <>
        <button type="button" className="is-ghost" onClick={onClose}>
          Close
        </button>
        <button
          type="button"
          className="is-primary"
          onClick={() => {
            if (!note) return
            onEdit(note)
          }}
        >
          <Pencil size={14} />
          Edit
        </button>
      </>
    }
  >
    {note ? (
      <div className="note-detail">
        <div className={`note-detail__meta is-${note.color}`}>
          <span className="note-detail__subject">{note.subject}</span>
          {note.dateLabel ? (
            <span className="note-detail__date">
              <Calendar size={12} />
              {note.dateLabel}
            </span>
          ) : null}
        </div>
        <div className="note-detail__content">{note.content}</div>
      </div>
    ) : null}
  </LearnerModal>
)

export default NoteDetailModal
